/**
 * DataDomain (Information Pillar) Validation Schemas
 */

import { z } from 'zod';
import { nameField, optionalBoundedText, optionalUrlField, requiredIdField } from './shared';

export const createDataDomainSchema = z.object({
  name: nameField(
    200,
    'Data domain name is required',
    'Data domain name must be less than 200 characters'
  ),
  description: optionalBoundedText(1000, 'Description must be less than 1000 characters'),
  domainType: z.enum(['master', 'reference', 'transactional', 'analytical', 'metadata'], {
    message: 'Domain type is required',
  }),
  dataStewardId: requiredIdField('Data steward is required'),
  owningBusinessUnitId: requiredIdField('Owning business unit is required'),
  technicalOwnerId: z.string().optional(),
  defaultClassification: z.enum(['public', 'internal', 'confidential', 'restricted'], {
    message: 'Classification is required',
  }),
  containsPII: z.boolean().optional().default(false),
  containsPCI: z.boolean().optional().default(false),
  containsPHI: z.boolean().optional().default(false),
  complianceFrameworks: z.array(z.string()).optional(),
  retentionPeriodDays: z.number().int().positive().optional(),
  lifecycleStatus: z
    .enum(['planned', 'developing', 'active', 'mature', 'deprecated', 'retired'])
    .optional(),
  criticalityLevel: z.enum(['critical', 'high', 'medium', 'low'], {
    message: 'Criticality level is required',
  }),
  tags: z.array(z.string()).optional(),
  notes: z.string().optional(),
  documentationUrl: optionalUrlField('Documentation URL must be a valid URL'),
});

export type CreateDataDomainFormData = z.infer<typeof createDataDomainSchema>;
